import { render, staticRenderFns } from "./Locales.vue?vue&type=template&id=0ab6201e&scoped=true&"
import script from "./Locales.vue?vue&type=script&lang=js&"
export * from "./Locales.vue?vue&type=script&lang=js&"
import style0 from "./Locales.vue?vue&type=style&index=0&id=0ab6201e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6201e",
  null
  
)

export default component.exports